import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../styles/contact.css";
import emailjs from 'emailjs-com'
import Swal from 'sweetalert2';
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { ChangeEvent, FormEvent, useState } from "react";


const Contact = () => {
  const SERVICE_ID = 'service_mjmidac';
  const TEMPLATE_ID = 'template_uu9axmg';
  const USER_ID = 'pL8ttfxEAHP6G7Dhh';

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handleMessageChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const handleFormSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const templateParams: Record<string, unknown>  = {
      email: email,
      name: name,
      message: message,
    };

    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID)
      .then((result) => {
        console.log(result.text);
        Swal.fire({
          icon: 'success',
          title: 'Message Sent Successfully',
        });
      })
      .catch((error) => {
        console.log(error.text);
        Swal.fire({
          icon: 'error',
          title: 'Ooops, something went wrong',
          text: error.text,
        });
      });

    setEmail('');
    setName('');
    setMessage('');
  };

  return (
    <div className="contactWrapper" id="contact">
      <div className="contact">
        <form onSubmit={handleFormSubmit} className="text-center p-4">
          <h4 className="mb-4">Contact me</h4>
          <div className="form-group">
            <input
              type="email"
              className="form-control mb-4 custom-input"
              placeholder="E-mail"
              value={email}
              onChange={handleEmailChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              className="form-control mb-4 custom-input"
              placeholder="Name"
              value={name}
              onChange={handleNameChange}
            />
          </div>
          <div className="form-group">
            <textarea
              className="form-control mb-4 rounded-0"
              placeholder="Message"
              value={message}
              onChange={handleMessageChange}
            ></textarea>
          </div>

          <button className="btmy" type="submit">
            Send
          </button>
        </form>
      <div className="mt-3 text-center">
      <p>Or contact me on LinkedIn or GitHub:</p>
      <a href="https://www.linkedin.com/in/anna-kucherenko1/">
        <FontAwesomeIcon className='icon' icon={faLinkedin} />
      </a>
      <a href="https://github.com/AnnaKucherenko1">
        <FontAwesomeIcon className='icon' icon={faGithub} />
      </a>
    </div>
    </div>
  </div>
  );
};
export default Contact;
